공<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>공지사항</h2>
            </div>
            <article class="view cmnity">
                <div class="search_box">
                    <p>총 게시물<strong> {{ noticeList.length }}</strong>건</p>
                    <div class="form_inline">
                        <input type="text" class="form_control" placeholder="검색어를 입력하세요.">
                        <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                    </div>
                </div>
                <div class="tab_contents">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list">
                                <colgroup>
                                    <col width="50">
                                    <col width="100">
                                    <col width="*">
                                    <col width="200">
                                    <col width="100">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>작성일자</th>
                                        <th>제목</th>
                                        <th>공지기간</th>
					                    <th>조회수</th>    
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="noticeList.length == 0">
                                        <td colspan="6"><span>데이터가 없습니다.</span></td>
                                    </tr>
                                    <tr v-for="(item, index) in noticeList" :key="index" @click="fn_move_dtl_page(item.board_notice_id)">
                                    <td><span>{{ item.no ? td.no : index + 1 }}</span></td>
                                    <td><span>{{ item.reg_dt }}</span></td>
                                    <td class="al">
                                        <span class="notice-impt-badge" v-if="item.board_notice_impt_yn == 'Y'">중요</span>
                                        <span>{{ item.board_notice_title }}</span>
                                    </td>
                                    <td><span>{{ item.board_notice_start_dt}} ~ {{item.board_notice_end_dt}}</span></td>
                                    <td><span>{{ item.read_cnt }}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
                    </div>
                </div>
            </article>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"

export default {
    name: 'NoticeList',
    components: {
      Pagination
    },
    data() {
      return {
        searchInfo : {
            title : '',
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }                
        },
		    pagingShow : false,
        noticeList: []
      }
    },
    created(){
        //this.fn_search();
    },
    mounted(){
        this.fn_search();
    },
    methods : {
        fn_search(){
            axios
                .post("/api/user/board/getNoticeList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.noticeList = res.data.noticeList;

                    console.log("@@@@ noticeList : %o",this.noticeList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }                        

                })
                .catch((err) => console.log(err));
        },
        fn_move_dtl_page(noticeId){
          console.log("@@@@@ noticeId : %o",noticeId);
          this.$store.dispatch('detailSearchInfo/setSearchId', noticeId);
          this.$router.push(`/noticeDetail`);
        }
    }
}
</script>

<style scoped>
.notice-impt-badge {
  display: inline-block;
  background-color: #e53935;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 4px;
  padding: 2px 7px;
  margin-right: 8px;
  vertical-align: middle;
  line-height: 1.6;
}
</style>
